<template>
  <div class="registration-upload">
    <form id="app" @submit.prevent="submitUpload" class="card-doc-upload">
      <md-card md-with-hover v-if="uploadFileSpinner">
        <md-card-content>
          <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
        </md-card-content>
      </md-card>

      <md-card md-with-hover v-if="!uploadFileSpinner">
        <md-card-content>
          <div class="md-title title-style">
            {{ $t("message.replyToCustomerService") }}
          </div>
          <div class="md-subhead">{{ $t("message.allMandatory") }}</div>
          <md-field :class="messageClass" md-clearable>
            <label for="mailSubject">{{ $t("message.subject") }}</label>
            <md-input
              v-model="mailSubject"
              name="mailSubject"
              type="text"
              id="mailSubject"
              value="mailSubject"
            ></md-input>
            <span class="md-error">{{ $t("message.complCampo") }}</span>
          </md-field>
          <md-field md-clearable>
            <label>{{ $t("message.inserisciMess") }}</label>
            <md-textarea v-model="textarea" md-counter="200"></md-textarea>
          </md-field>
          <md-field>
            <md-icon>attach_file</md-icon>
            <label>{{ $t("message.caricaFile") }}</label>
            <md-input
              name="filesText"
              type="text"
              id="filesText"
              @click="triggerInputFile"
              readonly
            ></md-input>
            <input
              type="file"
              multiple
              value="upload"
              accept="image/*, .pdf"
              @change="storePDF($event)"
              name="filesIE"
              id="filesIE"
              style="display: none"
            />

            <span>{{ $t("message.fileLimit") }}</span>
            <span class="md-error" v-if="isEmpty">{{
              $t("message.caricaFile")
            }}</span>
          </md-field>
          <md-list class="md-double-line" v-if="file.length > 0">
            <md-subheader style="text-align: left; padding: 20px 30px">{{
              $t("message.sentFiles")
            }}</md-subheader>

            <md-list-item v-for="(item, index) in file" v-bind:key="item.name">
              <md-icon class="md-primary">attach_file</md-icon>

              <div class="md-list-item-text">
                <span>{{ item.name }}</span>
              </div>

              <md-button
                class="md-icon-button md-list-action"
                @click="cancelFile(index)"
              >
                <md-icon>cancel</md-icon>
              </md-button>
            </md-list-item>
          </md-list>
          <br />
          <md-button
            class="md-raised md-accent"
            :md-ripple="false"
            type="submit"
            @submit="submitUpload()"
            :disabled="
              file == null ||
                textarea.trim().length == 0 ||
                mailSubject.trim().length == 0
            "
            value="Submit"
            >{{ $t("message.send") }}</md-button
          >
        </md-card-content>
        <md-button
          class="md-raised md-accent"
          :md-ripple="false"
          :to="{ name: 'PatientDownload' }"
          value="Back"
          >{{ $t("message.goBack") }}</md-button
        >
      </md-card>
    </form>
    <div>
      <md-dialog-confirm
        :md-active.sync="logout_active"
        :md-title="$t('message.disconnetti')"
        :md-content="$t('message.disconMessage')"
        :md-confirm-text="$t('message.exit')"
        :md-cancel-text="$t('message.cancel')"
        @md-cancel="logout_active = false"
        @md-confirm="logout()"
      />

      <!--<md-button class="md-primary md-raised" @click="showDialog = true">Show Dialog</md-button>-->
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import parsley from "parsleyjs";

import $ from "jquery";
import axios from "axios";
import "firebase/firestore";

import "firebase/auth";
import languagePicker from "../components/language-picker/LanguagePicker.vue";

export default {
  name: "registration-upload",
  data() {
    return {
      patientID: null,
      communicationID: null,
      locationID: null,
      filesText: "",
      logout_active: false,
      showDialog: false,
      uploadFileSpinner: true,
      isEmpty: false,
      mailSubject: "",
      textarea: "",
      multiple: null,
      file: [],
      idsFileDrive: [],
      fileName: null,
      user: null,
      showLogoutOptions: false,
      name: null,
      surname: null,
      patientMail: null,
      patientTelNumber: null,
      birthDate: null,
      id_patient: null,
      patients: [],
      isIE: false,
      receiptSubject: "Humanitas - Conferma invio comunicazione",
      receiptBody:
        "Gentile Paziente,<br /><br/>" +
        "la sua comunicazione è stata inviata correttamente.<br /><br />" +
        "Per visualizzare lo storico dei file ricevuti ad Humanitas, " +
        'la invitiamo a collegarsi alla piattaforma Comunicazione Sicura, cliccando <a href="((LINK))">qui</a>.<br />' +
        "<br />" +
        "Il servizio garantisce la massima sicurezza e riservatezza nel trattamento dei suoi dati, secondo " +
        "la vigente normativa in materia di protezione dei dati personali.<br /><br />" +
        "La ringraziamo per l’attenzione.<br />" +
        "Cordiali saluti,<br />" +
        "IRCCS Istituto Clinico Humanitas"
    };
  },
  computed: {
    messageClass() {
      if (!this.$store.state.detailPhone) {
        //console.log("mancano i dati");
      } else {
        return true;
      }
    }
  },
  mounted: function() {
    //console.log(this.$route.query.ref)
    // controllo esistenza stringa in firestorage
    // controllo auth

    var self = this;
    console.log(self.$store.state.communicationID);
    var ua = window.navigator.userAgent;
    self.isIE = /MSIE|Trident/.test(ua);

    var db = firebase.firestore();
    //console.log(self.$store.state.detailPhone);
    var query = db
      .collection("patients")
      .where("patientTelNumber", "==", self.$store.state.detailPhone);

    /*query.get().then(function(querySnapshot) {
      console.log(querySnapshot["docs"].length);
      if (querySnapshot["docs"].length == 0) {
        console.log("sei un nuovo paziente");
        self.$router.push({ path: "/new-phone" });
      } else {*/
    var user = firebase.auth().currentUser;
    //console.log(user);
    if (user) {
      // da mettere ciclo per controllare se + providerData
      if (user.providerData[0].providerId == "phone") {
        //console.log("Phone-Authenticated user");
        self.uploadFileSpinner = false;
        self.patientID = self.$store.state.patientID;
        firebase
          .auth()
          .currentUser.getIdToken(/* forceRefresh */ true)
          .then(function(idToken) {
            axios
              .get("/api/patientInfo/" + self.patientID, {
                headers: {
                  Authorization: "Bearer " + idToken
                }
              })
              .then(function(data) {
                console.log("SUCCESS!!");
                console.log(data.data.data);
                self.patientMail = data.data.data["patientMail"];
                self.patientTelNumber = data.data.data["patientTelNumber"];
                self.id_patient = self.patientID;
              })
              .catch(function() {
                //console.log("FAILURE!!");
              });
          });
        self.communicationID = self.$store.state.communicationID;
        self.locationID = self.$store.state.locationID;
        //var checkUserRef = self.checkUserRegistration();
        //check utente codice
        //get file URL
      } else {
        self.$store.commit("setRedirectPath", self.$route.fullPath);
        //console.log("User not Phone-Authenticated");
        self.$router.push("/phone-auth");
      }
    } else {
      //console.log("User not Authenticated");
      self.$store.commit("setRedirectPath", self.$route.fullPath);
      self.$router.push("/phone-auth");
    }
    // console.log(this.$store.state.detailName, this.$store.state.detailSurname, this.$store.state.detailPrimaryMail, this.$store.state.detailSecondaryMail, this.$store.state.detailPhone)

    //}
    //});
  },
  methods: {
    cancelFile: function(index) {
      var self = this;
      self.file.splice(index, 1);
    },
    triggerInputFile: function() {
      document.getElementById("filesIE").click();
    },
    choosePatient: function(item) {
      var self = this;
      //console.log("choosepatient");
      self.id_patient = item.id;
      self.name = item.patientName;
      self.surname = item.patientSurname;
      self.patientMail = item.patientMail;
      self.patientBirthDate = item.patientBirthDate;
      self.patientTelNumber = item.patientTelNumber;
      if (self.showDialog) self.showDialog = false;
      axios
        .post(
          "/api/logging",
          {
            component: "PAZIENTE",
            event: "Login e accetazione trattamento dati",
            patientID: self.id_patient
          },
          {
            headers: {
              //Authorization: 'Bearer ' + idToken
            }
          }
        )
        .then(function(data) {
          //console.log("SUCCESS!!");
        })
        .catch(function() {
          //console.log("FAILURE!!");
        });
    },
    logout: function() {
      var self = this;
      firebase
        .auth()
        .signOut()
        .then(function() {
          self.$router.push({
            path: "/"
          });
        });
    },
    validateEmailAddress: function(email) {
      var re = /^[\w]+([\.\w\-\+\_])*@[\w]+([\.\w\-\+\_])*\.+[a-zA-Z]{2,}$/;
      return re.test(String(email).toLowerCase());
    },
    validatePhoneNumber: function(phoneNumber) {
      var re = /^\+[0-9]*$/;
      return re.test(String(phoneNumber));
    },
    validateBirthDate: function(birthDate) {
      var re = /^((\d{2})\/(\d{2})\/(\d{4}))$/;
      return re.test(String(birthDate));
    },
    storePDF: function(e) {
      var self = this;
      //console.log(e.target.files);
      for (var j = 0; j < e.target.files.length; j++) {
        //console.log(e.target.files[j]);
        self.file.push(e.target.files[j]);
      }
      /*var self = this;
      self.file = e.target.files;
      if (self.isIE){
        //this.filesText = 'test'
        var names = [];
        for (var i=0; i<self.file.length; i++){
          names.push(self.file[i].name);
        }
        self.filesText = names.join(', ');
        //this.filesText = this.file.map(function(elem){
        //  return elem.name;
        //}).join(", ");
      }*/
    },
    upload2Storage: function(fbBucketName, file) {
      //console.log(file);
      var self = this;
      // create a storage ref
      var storageRef = firebase
        .storage()
        .ref(
          `${fbBucketName}/${self.patientTelNumber}/${self.id_patient}/${
            file.name
          }`
        );
      // upload file
      var uploadTask = storageRef.put(file);
      // update progress bar
      uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        function(snapshot) {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          //console.log("Upload is " + progress + "% done");
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              //console.log("Upload is paused");
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              //console.log("Upload is running");
              break;
          }
        },
        function(error) {
          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          switch (error.code) {
            case "storage/unauthorized":
              // User doesn't have permission to access the object
              break;
            case "storage/canceled":
              // User canceled the upload
              break;
            case "storage/unknown":
              // Unknown error occurred, inspect error.serverResponse
              break;
          }
        },
        function() {
          uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            //console.log('url');
            self.downloadURL = downloadURL;
            var updateToHumanitasCollection = self.updateToHumanitasCollectionHumanitas(
              downloadURL,
              file.name
            );
            axios
              .post(
                "/api/logging",
                {
                  component: "PAZIENTE",
                  event: "Caricamento allegato",
                  patientID: self.id_patient,
                  communicationID: self.communicationID,
                  description: file.name + " - " + downloadURL
                },
                {
                  headers: {
                    //Authorization: 'Bearer ' + idToken
                  }
                }
              )
              .then(function(data) {
                //console.log("SUCCESS!!");
              })
              .catch(function() {
                //console.log("FAILURE!!");
              });
          });
        }
      );
    },
    updateToHumanitasCollectionHumanitas: function(filesUrl, nomeFile) {
      var self = this;
      //console.log('update history');
      firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ true)
        .then(function(idToken) {
          axios
            .post(
              "/api/updateHistory",
              {
                fileName: nomeFile,
                patientID: self.patientID,
                communicationID: self.communicationID,
                locationID: self.locationID,
                downloadUrl: filesUrl,
                collectionName: "toHumanitas",
                template: "",
                activityState: "Nuovo",
                from: "patient",
                comm_object: self.mailSubject,
                comm_text: self.textarea
              },
              {
                headers: {
                  Authorization: "Bearer " + idToken
                }
              }
            )
            .then(function() {
              //console.log("toHumanitas history updated");
            })
            .catch(function() {
              //console.log("toHumaitas history update failed");
            });
        });
    },
    sendMail2Doc: function() {
      var self = this;
      firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ true)
        .then(function(idToken) {
          axios
            .post(
              "/api/sendmail",
              {
                emailSubject: self.receiptSubject,
                emailBody: self.receiptBody,
                userMail: self.patientMail,
                userNameSurname: self.name + " " + self.surname
              },
              {
                headers: {
                  Authorization: "Bearer " + idToken
                }
              }
            )
            .then(function(response) {
              //console.log("Email sent");
              self.uploadFileSpinner = false;
              var filenames = [];
              var allegati = "";
              if (self.file) {
                for (var i = 0; i < self.file.length; i++) {
                  filenames.push(self.file[i].name);
                }
                allegati = "\nAllegati: " + filenames.join(", ");
              }

              axios
                .post(
                  "/api/logging",
                  {
                    component: "PAZIENTE",
                    event: "Invio Comunicazione",
                    patientName: self.id_patient,
                    communicationID: self.communicationID,
                    description: self.textarea + allegati
                  },
                  {
                    headers: {
                      //Authorization: 'Bearer ' + idToken
                    }
                  }
                )
                .then(function(data) {
                  //console.log("SUCCESS!!");
                })
                .catch(function() {
                  //console.log("FAILURE!!");
                });
              self.$router.push({ path: "/act-options" });

              return true;
            })
            .catch(function(error) {
              self.uploadFileSpinner = false;
              //console.log("Error sending mail " + error);
              //console.error('/getContacts ERROR: ' + error)
              self.$notify({
                group: "foo",
                title: self.$t("message.sendMailError"),
                text: "",
                duration: 600,
                max: 1
              });
            });
        });
    },
    checkUserRegistration: function() {
      var self = this;
      var db = firebase.firestore();
      var query = db
        .collection("patients")
        .where("patientTelNumber", "==", self.$store.state.detailPhone);

      query.get().then(function(querySnapshot) {
        //console.log(querySnapshot["docs"].length);

        if (querySnapshot["docs"].length > 1) {
          querySnapshot.forEach(function(doc) {
            var temp_patient = {
              id: doc.id,
              patientMail: doc.data().patientMail,
              patientBirthDate: doc.data().patientBirthDate,
              patientName:
                doc
                  .data()
                  .patientName.charAt(0)
                  .toUpperCase() + doc.data().patientName.slice(1),
              patientSurname:
                doc
                  .data()
                  .patientSurname.charAt(0)
                  .toUpperCase() + doc.data().patientSurname.slice(1),
              patientTelNumber: doc.data().patientTelNumber
            };
            self.patients.push(temp_patient);
            self.showDialog = true;
            //console.log(doc.data())
          });
        } else if (querySnapshot["docs"].length == 1) {
          querySnapshot.forEach(function(doc) {
            //console.log(doc.data());
            var temp_patient = {
              id: doc.id,
              patientMail: doc.data().patientMail,
              patientBirthDate: doc.data().patientBirthDate,
              patientName:
                doc
                  .data()
                  .patientName.charAt(0)
                  .toUpperCase() + doc.data().patientName.slice(1),
              patientSurname:
                doc
                  .data()
                  .patientSurname.charAt(0)
                  .toUpperCase() + doc.data().patientSurname.slice(1),
              patientTelNumber: doc.data().patientTelNumber
            };
            self.choosePatient(temp_patient);
            self.patients.push(temp_patient);
            //console.log(doc.data())
          });
        } else {
          //console.log("si è verificato un errore");
        }
      });
    },
    submitUpload: function() {
      var self = this;
      if (!self.file) {
        self.uploadFileSpinner = false;
        return {
          "md-invalid": self.isEmpty
        };
      } else {
        if (
          self.mailSubject.trim().length == 0 ||
          self.textarea.trim().length == 0
        ) {
          self.$notify({
            group: "foo",
            title: self.$t("message.allMandatory"),
            text: self.$t("message.mailFieldsErr"),
            duration: 600
          });
          return;
        }
        var total_size = 0;
        for (var i = 0; i < self.file.length; i++) {
          var item = self.file[i];
          total_size += item.size;
        }
        //console.log(total_size);
        //console.log(total_size/1000000);
        if (total_size / 1000000 > 25) {
          self.$notify({
            group: "foo",
            title: self.$t("message.fileDimErrTit"),
            text: self.$t("message.fileDimErrMsg"),
            duration: 600
          });
          return;
        }
        self.$store.commit("patientsToClinic");

        self.uploadFileSpinner = true;
        var fbBucketName = "receivedFiles";
        for (var i = 0; i < self.file.length; i++) {
          var file = self.file[i];
          self.fileName = file.name;
          var upStorage = self.upload2Storage(fbBucketName, file);
        }
        var sedMailToPatient = self.sendMail2Doc();
      }
    }
  },
  components: {
    languagePicker
  }
};
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */
.logo_navbar {
  text-align: center;
  height: 40px;
  padding: 3px;
}

.logo_navbar {
  text-align: center;
  height: 40px;
  padding: 3px;
}

.md-card {
  width: 60%;
  margin: 4px;
  display: inline-block;
  vertical-align: center;
}

@media only screen and (max-width: 600px) {
  .md-card {
    width: 80%;
  }
}

.logo {
  margin-top: 60px;
  width: 10%;
  height: 10%;
}

.title-style {
  color: #027953;
  font-size: 20px;
}

.text-style {
  color: #027953;
  font-size: 15px;
  text-align: center;
  padding-top: 1%;
}

.logo_navbar {
  text-align: center;
  height: 40px;
  padding: 3px;
}

.person-icon {
  color: #027953;
}

.logout {
  margin-top: 40px;
}

.home-button {
  width: 487px;
}

.nav-style {
  height: 50px;
}

.second-navbar {
  background-color: #027953;
  font-size: 26px;
  font-weight: bold;
  color: #ffffff;
  padding: 1.3%;
}

.text-card {
  text-align: right;
  color: grey;
}

.simple-text {
  color: black;
  font-size: 17px;
}

.button-text {
  padding-top: 6%;
  padding-left: 1%;
  float: right;
}

.first-nav {
  background-color: #ffffff !important;
}

.user-mail {
  background-color: #f2f1f2;
  text-transform: lowercase;
  border-radius: 22px;
}

.cap {
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// src/views/RegistrationUploadFile.vue